export default __webpack_public_path__ + "static/media/N_wdt_c_cap_5.fc4b506c.mp3";